var path = 'areas/master/views/page-banners.html';
var html = "<div id=page-banners> <div class=\"alert alert-warning alert-page\" ng-show=isInMaintenanceMode> <p>This Octopus server is currently undergoing maintenance, and is read-only. Only Octopus administrators may make changes.</p> </div> </div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/areas/master/views/page-banners.html
// module id = 834
// module chunks = 1